import * as React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react'
import UserStore from '../../../Stores/UserStore'
import { history } from '../../../Routing'
import LocalizationStore from '../../../Stores/LocalizationStore'
import HttpActionsService from '../../../Services/HttpActionsService'
import { Link } from 'react-router-dom'
import { Button, ButtonToolbar } from 'react-bootstrap'
import PaymentsStore from '../../../Stores/PaymentsStore'
import {
    CreatePaymentRequest,
    getPaymentSourceText,
    getPaymentStatusText,
    getPaymentTypeText,
    getPaymentDirectionText, PaymentType, PaymentStatus, PaymentSource, PaymentDirection
} from '../../../Model/Payment'
import QuestionnairesStore from '../../../Stores/QuestionnairesStore'
import { ExternalDataSourceType } from '../../../Model/PaymentPrefillForm'

export interface IPaymentPageProps {
    localizationStore?: LocalizationStore
    paymentsStore?: PaymentsStore
    userStore?: UserStore
    httpActionsService?: HttpActionsService
    questionnairesStore?: QuestionnairesStore
}

@inject('localizationStore')
@inject('userStore')
@inject('httpActionsService')
@inject('paymentsStore')
@inject('questionnairesStore')
@observer
export default class CreatePaymentPage extends React.Component<IPaymentPageProps> {

    payPenalty(amount: number) {
        let createPaymentQuestionnaireModel = this.props.paymentsStore!.getCreatePaymentQuestionnaireModel!

        this.props.httpActionsService!.getQuestionnaireByCreditNumAndSource(
            parseInt(createPaymentQuestionnaireModel.questionnaire.credit.creditNumber, 10),
            ExternalDataSourceType.SRS,
            amount,
            PaymentStatus.Done,
            PaymentSource.Cash,
            createPaymentQuestionnaireModel.createPaymentRequest.paymentDateTime,
            PaymentType.Penalty,
            PaymentDirection.Deposit)

        history.push('/payment')
    }

    render() {
        const { localizationStore, paymentsStore, httpActionsService, questionnairesStore } = this.props

        let currentPenalty = questionnairesStore!.getCurrentNotPaidPenalty

        let createPaymentQuestionnaireModel = paymentsStore!.getCreatePaymentQuestionnaireModel!
        if (
            !createPaymentQuestionnaireModel ||
            !createPaymentQuestionnaireModel.createPaymentRequest ||
            !createPaymentQuestionnaireModel.questionnaire ||
            !createPaymentQuestionnaireModel.questionnaire.id) {
            return (
                <div>
                    <h4 className="payment-notification">{localizationStore!.t!('Questionnaire data not found')}</h4>
                </div>
            )
        }

        if (currentPenalty > 0 &&
            createPaymentQuestionnaireModel.createPaymentRequest.paymentType !== PaymentType.Penalty) {
            return (
                <div className="payment-notification">
                    <h4>
                        {localizationStore!.t!('Penalty not paid')}.
                        {localizationStore!.t!('Current penalty amount')}: {currentPenalty}
                    </h4>
                    <Button onClick={() => { this.payPenalty(currentPenalty) }}>
                        {localizationStore!.t('Add payment')} ({currentPenalty})
                    </Button>
                </div>
            )
        }

        if (isNaN(createPaymentQuestionnaireModel!.createPaymentRequest!.amount) ||
            createPaymentQuestionnaireModel!.createPaymentRequest!.amount < 0) {
            return (
                <div>
                    <h4 className="payment-notification">{localizationStore!.t!('Amount not valid')}</h4>
                </div>
            )
        }

        let q = createPaymentQuestionnaireModel.questionnaire

        return (
            <div className="paymentWrapper">
                <Link className="paymentQInfo" to={'/questionnaire/' + q.id}>ID: {q.id}</Link>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('creditNumber')}</span>
                    <span>{q.credit.creditNumber}</span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('clientId')}</span>
                    <span>{q.client.id}</span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('source')}</span>
                    <span>{q.orderSource}</span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('Full name')}</span>
                    <span>{q.client.surname} {q.client.name} {q.client.middleName}</span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('birthday')}</span>
                    <span>{q.client.birthday}</span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('email')}</span>
                    <span>{q.client.email}</span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('pin')}</span>
                    <span>{q.client.passport.pin}</span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('passportSeries')}</span>
                    <span>{q.client.passport.series}</span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('passportNumber')}</span>
                    <span>{q.client.passport.number}</span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('amountSum')}</span>
                    <span>{createPaymentQuestionnaireModel.createPaymentRequest.amount}&nbsp;AZN</span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('paymentStatus')}</span>
                    <span>
                        {
                            getPaymentStatusText(createPaymentQuestionnaireModel.createPaymentRequest.paymentStatus)
                        }
                    </span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('paymentDirection')}</span>
                    <span>
                        {
                            getPaymentDirectionText(
                                createPaymentQuestionnaireModel.createPaymentRequest.paymentDirection
                            )
                        }
                    </span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('paymentType')}</span>
                    <span>
                        {
                            getPaymentTypeText(createPaymentQuestionnaireModel.createPaymentRequest.paymentType)
                        }
                    </span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('paymentSource')}</span>
                    <span>
                        {
                            getPaymentSourceText(createPaymentQuestionnaireModel.createPaymentRequest.paymentSource)
                        }
                    </span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('paymentDateTime')}</span>
                    <span>{createPaymentQuestionnaireModel.createPaymentRequest.paymentDateTime}</span>
                </div>
                <div className="paymentQInfo">
                    <span>{localizationStore!.t!('description')}</span>
                    <textarea
                        className="payment-description"
                        onChange={(e: React.ChangeEvent) => {
                            httpActionsService!.updateCreatePaymentDescription(e.target['value'])
                        }
                        }
                    />
                </div>
                <ButtonToolbar>
                    <Button
                        onClick={() => { history.push('/') }}
                        bsStyle="link"
                    >
                        {localizationStore!.t!('Cancel')}
                    </Button>
                    <Button
                        hidden={!q.id}
                        onClick={() => {
                            history.push('/createPaymentSuccess')
                            httpActionsService!
                                .createPayment(
                                    new CreatePaymentRequest(
                                        q.id,
                                        createPaymentQuestionnaireModel.createPaymentRequest.amount,
                                        createPaymentQuestionnaireModel.createPaymentRequest.paymentStatus,
                                        createPaymentQuestionnaireModel.createPaymentRequest.paymentSource,
                                        createPaymentQuestionnaireModel.createPaymentRequest.paymentDateTime,
                                        createPaymentQuestionnaireModel.createPaymentRequest.paymentType,
                                        createPaymentQuestionnaireModel.createPaymentRequest.paymentDirection,
                                        createPaymentQuestionnaireModel.createPaymentRequest.description)
                                )
                        }}
                        type="submit"
                        bsStyle="success"
                    >
                        {localizationStore!.t!('Create')}
                    </Button>

                </ButtonToolbar>

            </div >
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Payment/CreatePaymentPage.tsx